var map = {
	"./authorize.svg": 1199,
	"./canceled.svg": 1200,
	"./capture.svg": 1201,
	"./card-authentication-line.svg": 1202,
	"./collect-card.svg": 1203,
	"./created.svg": 1204,
	"./failed.svg": 1205,
	"./processing.svg": 1206,
	"./requires-action-line.svg": 1207,
	"./requires-confirmation.svg": 1208,
	"./requires-payment-method.svg": 1209,
	"./succeeded.svg": 1210,
	"./verified.svg": 1211
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1198;